import Vue from 'vue'
import Router from 'vue-router'
import startingPage from './components/01/01.vue'
// import startingPage from './components/starting-page/starting-page.vue'
// import Hello from './components/hello/hello.vue'
// import Choice from './components/choice/choice.vue'
// import ChoiceHard from './components/choice-hard/choice-hard.vue'
// import Chat from './components/chat/chat.vue'
import NotFoundPage from '../views/404.vue';
import Menu from '@/views/menu.vue'
import CookiePolicy from '@/views/terms&etc/cookie-policy.vue'
import TermsOfUse from '@/views/terms&etc/terms-of-use.vue'
import PrivacyPolicy from '@/views/terms&etc/privacy-policy.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: '404',
      component: NotFoundPage
    },

    {
      path: '/menu',
      name: 'menu',
      component: Menu
    },

    {
      path: '/',
      name: 'home',
      component: startingPage,
      props: {
        msg: 'digital'
      }
    },

    // {
    //   path: '/',
    //   name: 'home',
    //   component: startingPage,
    //   props: {
    //     msg: 'digital'
    //   }
    // },

    // {
    //   path: '/hello',
    //   name: 'hello',
    //   component: Hello
    // },

    // {
    //   path: '/choice',
    //   name: 'choice',
    //   component: Choice
    // },

    // {
    //   path: '/choice-hard',
    //   name: 'choice-hard',
    //   component: ChoiceHard
    // },

    // {
    //   path: '/chat',
    //   name: 'chat',
    //   component: Chat
    // },

    {
      path: '/cookie-policy',
      name: 'cookie-policy',
      component: CookiePolicy
    },

    {
      path: '/terms-of-use',
      name: 'terms-of-use',
      component: TermsOfUse
    },

    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy
    },


  ]
})